const SCRIPT_ID = 'recaptcha-v3-script';

function requireRecaptchaSiteKey(siteKey: string | undefined): string {
    if (!siteKey || !siteKey.trim()) {
        throw new Error('Missing public reCAPTCHA site key');
    }

    return siteKey;
}

function loadScript(siteKey: string): Promise<void> {
    if (document.getElementById(SCRIPT_ID)) return Promise.resolve();
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('reCAPTCHA script failed to load'));
        document.head.appendChild(script);
    });
}

export const useRecaptcha = () => {
    const config = useRuntimeConfig();

    const execute = async (action: string): Promise<string> => {
        const siteKey = requireRecaptchaSiteKey(config.public.recaptchaSiteKey);
        await loadScript(siteKey);

        return new Promise((resolve, reject) => {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(siteKey, {action})
                    .then(resolve)
                    .catch(reject);
            });
        });
    };
    return {execute};
};
